// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__33PGX","inner":"Footer_inner___3BKr"};